<template>
  <div>
    <BaseModal
      name="withdrawalOfFundsModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
      @before-close="() => {}"
      @before-open="loadData"
    >
      <div class="tw-app-modal__container !tw-text-[15px]">
        <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('withdrawalOfFundsModal')"
        ></button>

        <div class="">
          <div class="tw-app-modal__title">
            {{ dataLang["reg_fin_text_68"] }}
          </div>

          <div
            @click="$modal.show('withdrawalOfFundsModalDetails')"
            class="hover:tw-underline tw-cursor-pointer tw-flex tw-justify-center tw-gap-[10px] tw-bg-[#F5F5F5] tw-py-[4px] tw-px-[10px] tw-text-forTitle tw-text-[14px] tw-mb-[15px]"
          >
            <img :src="require(`@/assets/icons/warning-dark.svg`)" width="20" />
            Прочтите перед выводом
          </div>
          <div
            class="tw-grid tw-grid-cols-[200px_auto] tw-gap-[15px] tw-mb-[5px]"
          >
            {{ dataLang["reg_fin_text_80"] }}:
            <div class="tw-font-[700]">
              {{ balance && balance.split(".")?.join(",") }}
            </div>
          </div>

          <div
            class="tw-grid tw-grid-cols-[200px_auto] tw-gap-[15px] tw-mb-[5px]"
          >
            Минимальный остаток:
            <div class="tw-font-[700]">5000,00</div>
          </div>

          <div class="tw-grid tw-grid-cols-[200px_auto] tw-gap-[15px]">
            Можно вывести до:
            <div v-if="balance - 5000 >= 0" class="tw-font-[700]">
              {{
                String((balance - 5000).toFixed(2))
                  .split(".")
                  .join(",")
              }}
            </div>
            <div v-else class="tw-font-[700]">0</div>
          </div>

          <div class="tw-flex tw-gap-[15px] tw-items-center tw-mt-[15px]">
            <div class="tw-font-[700] tw-whitespace-nowrap">Сумма вывода</div>
            <BaseInputNew
              inputClass="tw-app-input-type-3 !tw-text-[18px] tw-font-bold"
              @input="(data) => (getsSum = data.value?.replace(',', '.'))"
              inputName="getsSum"
              :value="getsSum ? getsSum?.replace('.', ',') : null"
              nameSign=""
              :disabled="balance - 5000 <= 0"
              :forFinanceType="true"
              inputRef="getsSum__1"
            />
          </div>
          <div
            class="tw-bg-danger tw-py-[5px] tw-mt-[20px] tw-text-center tw-text-white tw-text-[14px]"
            v-if="getsSum > 0 && balance - 5000 < getsSum"
          >
            {{ dataLang["reg_fin_text_81"] }}
            {{
              String((balance - 5000).toFixed(2))
                .split(".")
                .join(",")
            }}
          </div>

          <div
            class="tw-bg-danger tw-py-[5px] tw-mt-[20px] tw-text-center tw-text-white tw-text-[14px]"
            v-if="getsSumIsEmpty && !getsSum"
          >
            Укажите сумму и повторите запрос
          </div>

          <div class="tw-my-[15px]">
            <div class="fw-bold tw-text-[15px] tw-mb-[8px]">
              {{ dataLang["reg_fin_text_73"] }}:
            </div>

            <div class="tw-text-[14px]">
              <div
                class="tw-grid tw-grid-cols-[120px_auto] tw-gap-[15px] tw-mb-[5px]"
                v-for="item in companySettingsDetails"
              >
                <div class="tw-text-forText">
                  {{ item.title }}
                </div>
                {{ item.value }}
              </div>
            </div>
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('withdrawalOfFundsModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reg_fin_text_57"] }}
            </button>
            <button
              @click="sendData"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["reg_fin_text_83"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="withdrawalOfFundsModalDetails"
      width="780"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('withdrawalOfFundsModalDetails')"
        ></button>

        <div class="[&_ul]:!tw-mb-0 [&_li]:!tw-mb-[5px]">
          <div v-html="dataLang['reg_fin_text_70']"></div>
          <ul class="ps-30 fsc-14 mb-15">
            <li>
              <div v-html="dataLang['reg_fin_text_71']"></div>
            </li>
          </ul>
          <div v-html="dataLang['reg_fin_text_72']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('withdrawalOfFundsModalDetails')"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Прочтено
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  components: {
    VeTable,
  },
  props: {},
  data() {
    return {
      listOptions: [],
      typeOperation: "",
      localLoading: false,
      dataForEmit: {},
      foundFrom: [],
      foundTo: [],
      currentId: null,
      balance: 0,
      getsSum: 0,
      getsSumIsEmpty: false,
      settings: {},
    };
  },
  methods: {
    loadData({ params }) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get("/whoami")
          .then((data) => {
            this.balance = data.data.data.company_balance;
          })
          .catch((e) => {})
          .finally(() => {}),
        GeneralService.get("/settings")
          .then((data) => {
            this.settings = data.data.data.rows[0];
          })
          .catch((e) => {})
          .finally(() => {}),
      ])
        .then(() => {})
        .finally(() => {
          this.localLoading = false;
        });
    },
    beforeClose(event) {
      this.dataForEmit = {};
      this.currentId = null;
      this.foundFrom = [];
      this.foundTo = [];
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      //   this.$refs[data.name].classList.remove('input-error')
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    sendData() {
      if (this.getsSum > 0) {
        this.getsSumIsEmpty = false;
        GeneralService.editOrCreate("/balance_out_requests/create", {
          amount: this.getsSum,
        })
          .then((data) => {
            this.$toast.success(data.data.message);
            this.$modal.show("zprosIsDone");
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          })
          .finally(() => {
            this.$modal.hide("withdrawalOfFundsModal");
          });
      } else {
        this.getsSumIsEmpty = true;
      }
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
    companySettingsDetails() {
      return [
        {
          title: this.dataLang["reg_fin_text_74"],
          value: this.settings.company_settings__set_req_company_name,
        },
        {
          title: this.dataLang["reg_fin_text_75"],
          value: this.settings.company_settings__set_req_inn,
        },
        {
          title: this.dataLang["reg_fin_text_76"],
          value: this.settings.company_settings__set_req_rs,
        },
        {
          title: this.dataLang["reg_fin_text_77"],
          value: this.settings.company_settings__set_req_bik,
        },
        {
          title: this.dataLang["reg_fin_text_78"],
          value: this.settings.company_settings__set_req_ks,
        },
      ];
    },
  },
};
</script>
